const SAVE_BUILD = 'app/manage/SAVE_BUILD';
const DELETE_BUILD = 'app/manage/DELETE_BUILD';
const LOAD_BUILD = 'app/manage/LOAD_BUILD';

export default {
  SAVE_BUILD,
  DELETE_BUILD,
  LOAD_BUILD,
};
